import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getStudyTasks,
  getStudyTask,
  clearLocalStudyTasks,
  clearLocalActiveStudyTask
} from './actions';

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  studyTask: { id: '', file: null, input: '', status: '', updated_at: '' },
  loading: { all: false, studyTask: false }
};

const slice = createSlice({
  name: 'studyTasks',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getStudyTasks.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getStudyTasks.fulfilled, (state, action) => {
        const { study_tasks, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...study_tasks], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getStudyTasks.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getStudyTask.pending, (state) => {
        state.loading.studyTask = true;
      })
      .addCase(getStudyTask.fulfilled, (state, action) => {
        const { study_task } = action.payload;
        const foundedStudyTask = !!_find(state.all.data, (s) => s.id === study_task.id);
        const updatedStudyTask = { ...state.studyTask, ...study_task };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedStudyTask ? _map(state.all.data, (e) => e.id === study_task.id ? { ...e, ...study_task } : e) : [...[study_task], ...oldAllData]; 
        const pagination = foundedStudyTask ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.studyTask = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedStudyTask) state.studyTask = updatedStudyTask;       
      })
      .addCase(getStudyTask.rejected, (state) => {
        state.loading.studyTask = false;
      })
      .addCase(clearLocalStudyTasks, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveStudyTask, state => {
        state.studyTask = initialState.studyTask;
      })
  }
})

export default slice.reducer;